import btn from './up-button'
Vue.directive('btn', btn)



// WEBPACK FOOTER //
// ./src/js/directives/up-button/index.js